export default "__VITE_ASSET__MMAYIcDZ__"